export var valuesCourseState = ["NotRegistered", "NotStarted", "Started", "Finished"];
/*

*/ 
//# sourceMappingURL=CourseState.js.map